module.exports = __webpack_public_path__ + "static/media/icon-spam.642315fe.svg";